import { render, staticRenderFns } from "./ActivityDetail.vue?vue&type=template&id=25f0283e&scoped=true"
import script from "./ActivityDetail.vue?vue&type=script&lang=js"
export * from "./ActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./ActivityDetail.vue?vue&type=style&index=0&id=25f0283e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f0283e",
  null
  
)

export default component.exports